import React from 'react'
import { toast } from 'react-toastify'
import { withTranslation } from 'react-i18next'
import ConfirmDialog from '../../shared/ConfirmDialog'

export default withTranslation()(function DeleteAccountConfirm({ handleClick, t }) {
  const confirmDelete = () => {
    // TODO: wire up once a delete-account endpoint is available
    toast.info(t('settings.account_security.delete_account.not_available'))
    handleClick()
  }

  return (
    <ConfirmDialog
      title={t('settings.account_security.delete_account.title')}
      description={t('settings.account_security.delete_account.confirmation')}
      confirmText={t('settings.account_security.delete_account.confirm')}
      danger
      onConfirm={confirmDelete}
      onCancel={handleClick}
    />
  )
})
